<form class="app-modal-form" [formGroup]="form" (ngSubmit)="submitForm()" autocomplete="off">

  <div class="form-group">
    <label>Старый пароль</label>

    <div class="icon-input">
      <input
        [type]="getInputType(oldPasswordHidden)"
        formControlName="old_password"
        autocomplete="nope"
      />
      <button
        type="button"
        class="password-toggle"
        (click)="oldPasswordHidden = !oldPasswordHidden"
        aria-label="Показать или скрыть пароль"
      >
        <svg-icon [src]="getIcon(oldPasswordHidden)"></svg-icon>
      </button>
    </div>

    <div class="form-errors" *ngIf="form.get('old_password')?.dirty">
      <div class="form-error" *ngIf="form.get('old_password')?.errors?.required">
        Введите старый пароль
      </div>
    </div>
  </div>

  <div class="form-group">
    <label>Новый пароль</label>

    <div class="icon-input">
      <input
        [type]="getInputType(newPasswordHidden)"
        formControlName="new_password"
        (ngModelChange)="invalidateForm()"
        autocomplete="new-password"
      />
      <button
        type="button"
        class="password-toggle"
        (click)="newPasswordHidden = !newPasswordHidden"
        aria-label="Показать или скрыть пароль"
      >
        <svg-icon [src]="getIcon(newPasswordHidden)"></svg-icon>
      </button>
    </div>

    <div class="form-errors" *ngIf="form.get('new_password')?.touched">
      <div class="form-error" *ngIf="form.get('new_password')?.errors?.required">
        Введите новый пароль
      </div>
      <div class="form-error" *ngIf="form.get('new_password')?.errors?.minlength">
        Минимальная длина пароля — 8 символов
      </div>
      <div class="form-error" *ngIf="form.get('new_password')?.errors?.maxlength">
        Максимальная длина пароля — 32 символа
      </div>
      <div class="form-error" *ngIf="form.get('new_password')?.errors?.pattern">
        Пароль должен содержать минимум: одну цифру, одну прописную и одну строчную латинскую букву, один специальный символ: #?!&#64;$%^*-
      </div>
    </div>
  </div>

  <div class="form-group">
    <label>Повторите новый пароль</label>

    <div class="icon-input">
      <input
        [type]="getInputType(repeatPasswordHidden)"
        formControlName="new_password_repeat"
        autocomplete="repeat-pass"
      />
      <button
        type="button"
        class="password-toggle"
        (click)="repeatPasswordHidden = !repeatPasswordHidden"
        aria-label="Показать или скрыть пароль"
      >
        <svg-icon [src]="getIcon(repeatPasswordHidden)"></svg-icon>
      </button>
    </div>

    <div class="form-errors" *ngIf="form.get('new_password_repeat')?.touched">
      <div class="form-error" *ngIf="form.get('new_password_repeat')?.errors?.required">
        Введите новый пароль еще раз
      </div>
      <div class="form-error" *ngIf="form.get('new_password_repeat')?.errors?.repeat">
        Пароли не совпадают
      </div>
    </div>
  </div>

  <div class="app-modal-form__actions app-modal-form__actions--right">
    <svg-icon
      name="spinner"
      class="app-modal-form__spinner icon-spinner"
      *ngIf="pending"
    ></svg-icon>

    <button
      class="app-modal-form__button app-modal-form__button--primary"
      type="submit"
      [attr.disabled]="pending ? true : null"
    >
      Сменить
    </button>
  </div>
</form>
